module.exports = __webpack_public_path__ + "img/chemicals-img-2.497927b9.png";